
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthHttp } from 'app/admin/services/token.service';
import { AppConfigService } from 'app/shared/services/app.config.service';



let AppConstant: any = {};

@Injectable()
export class LetterOfCreditService {

	constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
		AppConstant = appConfigServ;
	}

	saveLcIssuance(body) {
        return this.http.post(`credit/lc-issuance`, body).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
  
    updateLcIssuance(body, id) {
        console.log(body);
        return this.http.put(`credit/lc-issuance/${id}`, body).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
  
    deleteLcIssuance(id) {
        return this.http.delete(`credit/lc-issuance/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
  
    getLcIssuances() {
        return this.http.get(`credit/lc-issuance`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcIssuancesByLcIssuanceId(lcIssuanceId: number) {
        return this.http.get(`credit/lc-issuance/${lcIssuanceId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcIssuancesForApproval() {
        return this.http.get(`credit/lc-issuance/approval`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcIssuancesForRelease() {
        return this.http.get(`credit/lc-issuance/release`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcIssuancesForReleaseApproval() {
        return this.http.get(`credit/lc-issuance/release-approval`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveLcDocument(body) {
        return this.http.post(`credit/lc-document`, body).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateLcDocument(body, id) {
        return this.http.put(`credit/lc-document/${id}`, body).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    deleteLcDocument(id) {
        return this.http.delete(`credit/lc-document/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcDocuments(id) {
        return this.http.get(`credit/lc-document/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcDocumentsByLcIssuanceId(lcIssuanceId) {
        return this.http.get(`credit/lc-documents/${lcIssuanceId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveLcShipping(body) {
        return this.http.post(`credit/lc-shipping`, JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateLcShipping(body, id) {
        return this.http.put(`credit/lc-shipping/${id}`, JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    deleteLcShipping(id) {
        return this.http.delete(`credit/lc-shipping/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcShippings(id) {
        return this.http.get(`credit/lc-shipping/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcShippingsByLcIssuanceId(lcIssuanceId) {
        return this.http.get(`credit/lc-shippings/${lcIssuanceId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveLcCondition(body) {
        return this.http.post(`credit/lc-condition`, JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateLcCondition(body, id) {
        return this.http.put(`credit/lc-condition/${id}`, JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    deleteLcCondition(id) {
        return this.http.delete(`credit/lc-condition/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcCondition(id) {
        return this.http.get(`credit/lc-condition/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcConditionsByLcIssuanceId(lcIssuanceId) {
        return this.http.get(`credit/lc-conditions/${lcIssuanceId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    forwardLcIssuance(body) {
        console.log('forwarded =>');
        return this.http.post(`credit/lc-approval/forward`, JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    forwardLcRelease(body) {
        console.log('forwarded =>');
        return this.http.post(`credit/lc-release/forward`, JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getIFFLinesForLc(customerId) {
        console.log('Lines =>');
        return this.http.get(`credit/lc-issuance/lines/${customerId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getIFFLineDetails() {
        
    }

    getCurrentStaffActivities() {
        console.log('activities => ');
        return this.http.get(`admin/get-user-activities`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    searchForLC(searchString) {
        console.log('activities => ');
        return this.http.get(`credit/lc-search/${searchString}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    saveLcUssance(value) {
        return this.http.post(`credit/lc-ussance`, JSON.stringify(value)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    updateLcUssance(value, id) {
        return this.http.put(`credit/lc-ussance/${id}`, JSON.stringify(value)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcIssuancesForUssance() {
        return this.http.get(`credit/lc-issuance/ussance`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcIssuancesForUssanceApproval() {
        return this.http.get(`credit/lc-issuance/ussance-approval`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcUssanceByLcIssuanceId(lcIssuanceId) {
        return this.http.get(`credit/lc-ussance-lcIssuanceId/${lcIssuanceId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLcUssanceByLcUsanceId(lcUsanceId) {
        return this.http.get(`credit/lc-ussance-lcUsanceId/${lcUsanceId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    forwardLcUssance(body) {
        console.log('ussance =>');
        return this.http.post(`credit/lc/ussance-forward`, JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    saveReleaseAmount(body) {
        return this.http.post(`credit/lc-release`, body).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    UpdateReleaseAmount(body) {
        return this.http.put(`credit/lc-release`, body).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
}
